import Base from '../../base';
import { parseTree } from './utils';
import eventsListener from './eventsListener';
import GroupToolbar from './GroupToolbar';
import Datatable from './Datatable';
import ThumbGrid from './ThumbGrid';
import makeContextMenu from './makeContextMenu';
import Treeview from '../../../components/Treeview';
import Sidebar from '../../../components/Sidebar';
// import Uploader from '../../../components/Uploader';
import { spinner } from '../../../components/Spinner';
import MoveNodeModal from '../../../components/MoveNodeModal';
import NewChildNodeModal from '../../../components/NewChildNodeModal';
import AddResourcesModal from '../../../components/AddResourcesModal';
import BlockingProgressModal from '../../../components/BlockingProgressModal';
import _ from 'lodash';
import {
  fetchBundleSubtree,
  fetchNodeSidebar,
  fetchNodeContent,
  duplicateRequest,
  removeNodeRequest,
} from '../../../requests/bundles';
import Editables from '../../../components/Editables';
import QueryMetaSearch from '../../../components/QueryMetaSearch';

const TREEVIEW_SELECTOR = '#treeview-node';
const INITIAL_STATE = {
  sidebarNode: null,
  bundle_id: null
};

const CLIPBOARD_STORAGE_ITEM = 'dam.clipboard';

export default class Browse extends Base {
  // closeSidebar() {
  //   this.state.sidebarNode = null;
  //   // this.destroyUploader();
  //   this.sidebar.close();
  // }

  showSidebar(node) {
    this.state.sidebarNode = node;

    // if (!node) {
    //   this.closeSidebar();
    //   return;
    // }

    this.sidebar.updateContent(spinner());

    fetchNodeSidebar(this.state.bundle_id, node.uuid)
      .done((content) => {
        this.sidebar.updateContent(content);
        // this.initializeUploader(node);
        $('.Sidebar').find('select').select2({
          theme: 'bootstrap4'
          // minimumResultsForSearch: -1
        });
        new Editables(
          '.editable-bundle-meta-datum',
          {
            params: function(params) {
              //originally params contain pk, name and value
              params = {
                authenticity_token: gon.authenticity_token,
                values_attributes: [
                  {
                    id: this.dataset.valueId,
                    [`value_${this.dataset.valueType}`]: params.value
                  }
                ]
              };
              return params;
            },
            // mode: 'inline'
          }
        );


        // TODO: this is kind of hackish - refactor?
        const node = this.tree.findNode(this.state.current_uuid);
        new Editables(
          '.editable-bundle-meta-datum--general-title',
          {
            params: function(params) {
              //originally params contain pk, name and value
              params = {
                authenticity_token: gon.authenticity_token,
                values_attributes: [
                  {
                    id: this.dataset.valueId,
                    [`value_${this.dataset.valueType}`]: params.value
                  }
                ]
              };
              return params;
            },
            success: (response, newValue) => {
              $(document).trigger('tree:node:nameChanged', [node, newValue]);
            }
            // mode: 'inline'
          }
        );

        if(this.state.readOnly) {
          this.disableSidebarEditing();
        }
      });

    // this.sidebar.open();
  }

  reloadSidebar() {
    if (!this.state.sidebarNode) { return; }
    if(this.state.sidebarNode.uuid !== this.state.current_uuid){
      this.showSidebar(this.state.sidebarNode);
    }
  }

  showNewChildModal(node) {
    this.newChildNodeModal.loadNode(node);
  }

  showMoveChildModal(node) {
    this.moveNodeModal.loadNode(node);
  }

  handleRemoveNode(node, parent) {
    if (!confirm(I18n.t('admin.general.are_you_sure'))) { return; }

    this.handleRemoveNodeRequest(this.state.bundle_id, node, parent);
  }

  handleAddResources(node) {
    this.addResourcesModal.loadNode(node);
  }

  handleDuplicate(node, targetParent, options = {}) {
    // TODO: replace JS confirm with confirmation modal
    if(!confirm(`Stai per duplicare "${node.name}" in "${targetParent.name}". Sei sicuro?`)) { return; }

    const isPaste = options.isPaste || false;
    console.log('Duplicating node:', node.name, isPaste ? '(via paste)' : '(direct duplicate)');

    duplicateRequest({ source_uuid: node.uuid, target_parent_uuid: targetParent.uuid }).
    done((data) => {
      this.blockingProgressModal.watch(data.jid).
      then((result) => {
        console.log('BlockingProgressModal result:', result);

        const createdNode = this.parseCreatedNode(result);

        if (createdNode && createdNode.uuid) {
          console.log('Found created node:', createdNode);

          if (isPaste) {
            console.log('Setting paste result as current node');
            this.handleChildNodeCreated(createdNode, targetParent);
            this.highlightNewNode(createdNode);
          } else {
            console.log('Setting up highlight for duplicated node');
            this._pendingHighlightNode = createdNode.uuid;
            this.handleChildNodeCreated(createdNode, targetParent);
          }
        } else {
          console.warn('No created node found in result:', result);
          this._pendingHighlightParent = targetParent.uuid;
          this.handleChildNodeCreated(result.target, targetParent);
        }
      })
          .catch((error) => {
            console.error('Error in blockingProgressModal:', error);
          });
    });
  }
  handleClipboardCopy(node) {
    localStorage.setItem(CLIPBOARD_STORAGE_ITEM, JSON.stringify(node));
  }

  handleClipboardPaste(targetParent) {
    var node = JSON.parse(localStorage.getItem(CLIPBOARD_STORAGE_ITEM));
    this.handleDuplicate(node, targetParent, { isPaste: true });
  }

  handleContextMenuClick(node, action) {
    switch (action) {
    case 'info':
      return this.showSidebar(node.data);
    case 'new_child':
      return this.showNewChildModal(node.data);
    case 'new_sibling':
      return this.showNewChildModal(node.parent.data);
    case 'move_node':
      return this.showMoveChildModal(node.data);
    case 'remove_node':
      return this.handleRemoveNode(node.data, node.parent.data);
    case 'add_resources':
      return this.handleAddResources(node.data);
    case 'duplicate':
      return this.handleDuplicate(node.data, node.parent.data);
    case 'clipboard_copy':
      return this.handleClipboardCopy(node.data);
    case 'clipboard_paste':
      return this.handleClipboardPaste(node.data);
    case 'multiple_paste':
      return this.handleMultipleClipboardPaste(node.data);
    case 'select_all_children':
      return this.selectAllChildren(node);
    case 'deselect_all_children':
      return this.deselectAllChildren(node);
    default:
      console.log('Unhandled context menu'); // eslint-disable-line
    }
  }

  selectAllChildren(node) {
    if (node.children) {
      node.visit(childNode => {
        childNode.setSelected(true);
      });
    }
  }

// Deseleziona tutti i figli di un nodo
  deselectAllChildren(node) {
    if (node.children) {
      node.visit(childNode => {
        childNode.setSelected(false);
      });
    }
  }


  handleNodeLazyLoad(event, data) {
    const node = data.node;
    const deferred = new $.Deferred();

    data.result = deferred.promise();
    fetchBundleSubtree({ bundle_id: this.state.bundle_id, uuid: node.data.uuid })
      .done((result) => {
        deferred.resolve(parseTree(result.paths).children || []);
      });

    return data;
  }

  handleNodeMoved(node, destNode) {
    $(document).trigger('tree:node:changed', [destNode, node]);
    this.tree.removeNode(node.uuid);
    this.moveNodeModal.close();
  }

  handleChildNodeCreated(node, parent) {
    $(document).trigger('tree:node:changed', [parent, node]);
    this.newChildNodeModal.close();
  }

  highlightNewNode(node, attempt = 0) {
    const MAX_ATTEMPTS = 10;
    const DELAY = 100;
  
    setTimeout(() => {
      const treeNode = this.tree.findNode(node.uuid);
      if (treeNode) {
        treeNode.addClass('recently-created-node');
      } else if (attempt < MAX_ATTEMPTS) {
        this.highlightNewNode(node, attempt + 1);
      }
    }, DELAY);
  }

  handleAddedResources(parent, nodes) {
    this.addResourcesModal.close();
    $(document).trigger('tree:node:changed', [parent]);
  }

  handleMenuClick(event, data) {
    const node = data.node.data;
    this.visitNode(node);
  }

  visitNode(node) {
    if(node.uuid !== this.state.current_uuid) {
      const uuid = node.uuid;
      $('.three-panes__central-pane .central-pane__body').html(spinner());
      this.showSidebar(node);
      fetchNodeContent(this.state.bundle_id, uuid).done((body) => {
        this.updateContent(node, uuid, body);
      });
    }
  }

  updateContent(node, uuid, body) {
    // Update current state
    this.state = Object.assign(this.state, { current_uuid: uuid });

    // Update html
    $('.three-panes__central-pane').html($(body).html());
    this.initializeGroupToolbar();
    this.showCurrentVisualizationTypeElement();
    this.initializeDatatable();
    this.initializeThumbGrid();

    // Replace URL
    const path = Routes.browse_admin_bundle_path(this.state.bundle_id, { uuid: uuid });
    const newUrl = `${window.location.protocol}//${window.location.host}${path}`;
    Turbolinks.controller.history.push(newUrl);
    this.tree.setCurrent(uuid);
  }

  initializeTree() {
    const initialState = parseTree(gon.paths);
    initialState.expanded = true;

    this.tree = new Treeview(TREEVIEW_SELECTOR, {
      source: [initialState],
      lazyLoad: this.handleNodeLazyLoad.bind(this),
      contextMenu: makeContextMenu(this),
      onContextMenu: this.handleContextMenuClick.bind(this),
      click: (e, data) => {
        if(data.targetType === 'title') {
          this.handleMenuClick(e, data);
        }
        if(data.targetType === 'checkbox') {
          const node = data.node;
          const isSelected = !node.isSelected();

          // Seleziona/deseleziona tutti i figli, perché altrimenti viene selezionata alberatura completa.
          if (node.children) {
            node.visit((childNode) => {
              childNode.setSelected(isSelected);
            });
          }
        }
      },
      extensions: ['glyph'],
    }, {
      checkbox: true,
      selectMode: 2,
      glyph: {
        preset: 'material',
        map: {}
      },
      minExpandLevel: 2,
      icon: function(e, data) {
        const node = data.node;

        if(node.parent && node.parent.parent === null) {
          node.addClass('fancytree-node--root');
          return { addClass: 'material-icons', text: 'device_hub' };
        }

        if(node.data && node.icon) {
          return { addClass: 'material-icons', text: node.icon };
        }
      }
    });

    // Event listener per le selezioni
    $(TREEVIEW_SELECTOR).on('fancytreeselect', (event, data) => {
      this.updateMultiSelectionUI();
    });
  }

  destroyTree() {
    if (this.tree) {
      this.tree.destroy();
      this.tree = undefined;
    }
  }
  // tutti i nodi selezionati (con checkbox)
  getSelectedNodes() {
    if (!this.tree || !this.tree.tree) return [];
    return this.tree.tree.getSelectedNodes();
  }

// Cancellazione multipla

  handleMultipleDelete(){
    const selectedNodes = this.getSelectedNodes();
    if (selectedNodes.length === 0) {
      alert('Nessun nodo selezionato');
      return;
    }

    const groupNodes = selectedNodes.filter(node => {
      return node.data.typology === 'group_typology';
    });

    const wrapperNodes = selectedNodes.filter(node => {
      return node.data.typology === 'wrapper_typology';
    });

    console.log('Selected nodes:', selectedNodes.length);
    console.log('Group nodes to delete:', groupNodes.length);
    console.log('Wrapper nodes to delete:', wrapperNodes.length);

    const wrapperNodeData = wrapperNodes.map(node => node.data);
    const groupNodeData = groupNodes.map(node => node.data);

    const wrapperNames = wrapperNodeData.map(node => `• ${node.name}`).join('\n');
    const groupNames = groupNodeData.map(node => `• ${node.name}`).join('\n');

    let confirmMessage = `Stai per eliminare ${selectedNodes.length} elementi:\n\n`;
    if (groupNames) {
      confirmMessage += `Gruppi:\n${groupNames}\n\n`;
    }
    if (wrapperNames) {
      confirmMessage += `Wrapper:\n${wrapperNames}\n\n`;
    }
    confirmMessage += `Sei sicuro?`;

    if (!confirm(confirmMessage)) {
      return;
    }

    // Cancella tutti i nodi selezionati
    const allNodesToDelete = [...groupNodes, ...wrapperNodes];

    allNodesToDelete.forEach(node => {
      const parent = node.parent.data;

      this.handleRemoveNodeRequest(this.state.bundle_id, node.data, parent);
    });

    // Deseleziona tutti i nodi dopo la cancellazione
    this.clearAllSelections();
  }

  handleRemoveNodeRequest(bundleId, node, parent){
    removeNodeRequest(bundleId, node.uuid)
        .done(() => {
          if (parent.id) { // subtree deleted
            $(document).trigger('tree:node:deleted', [node, parent]);
          } else { // tree emptied
            $(document).trigger('tree:node:changed', [node]);
          }
        })
        .fail((error) => {
          console.error(`Errore durante la cancellazione del nodo ${node.name}:`, error);
        });
  }


// Copia multipla negli appunti
  handleMultipleClipboardCopy() {
    const selectedNodes = this.getSelectedNodes();
    if (selectedNodes.length === 0) {
      alert('Nessun nodo selezionato');
      return;
    }

    const wrapperNodes = selectedNodes.filter(node => {
      return node.data.typology === 'wrapper_typology';
    });

    if (wrapperNodes.length === 0) {
      alert('Nessun nodo wrapper selezionato da copiare');
      return;
    }

    console.log('Selected nodes:', selectedNodes.length);
    console.log('Wrapper nodes to copy:', wrapperNodes.length);

    const nodeData = wrapperNodes.map(node => node.data);
    localStorage.setItem(CLIPBOARD_STORAGE_ITEM + '_multiple', JSON.stringify(nodeData));
    console.log(`${wrapperNodes.length} nodi wrapper copiati negli appunti`);

    this.showTemporaryMessage(`${wrapperNodes.length} risorse copiati`);
  }

// Incolla multipla dagli appunti
  handleMultipleClipboardPaste(targetParent) {
    const nodesData = JSON.parse(localStorage.getItem(CLIPBOARD_STORAGE_ITEM + '_multiple') || '[]');
    if (nodesData.length === 0) {
      alert('Nessun nodo negli appunti');
      return;
    }

    if (!confirm(`Stai per duplicare ${nodesData.length} elementi in "${targetParent.name}". Sei sicuro?`)) {
      return;
    }

    this.handleMultipleDuplicate(nodesData, targetParent);
  }

  handleMultipleDuplicate(nodes, targetParent) {
    this.duplicateNodesSequentially(nodes, targetParent, 0);
  }
  
  finalizeMultipleDuplication(targetParent) {
    if (!this._createdNodes || this._createdNodes.length === 0) {
      $(document).trigger('tree:nodes:changed', [targetParent, []]);
      this.clearAllSelections();
      this._createdNodes = [];
      return;
    }
  
    $(document).trigger('tree:nodes:changed', [targetParent, this._createdNodes]);
  
    this.clearAllSelections();
    this._createdNodes = [];
  }

  parseCreatedNode(result) {
    if (result && result.target) {
      if (typeof result.target === 'string') {
        try {
          return JSON.parse(result.target);
        } catch (e) {
          console.error('Failed to parse target JSON:', e, result.target);
        }
      } else if (typeof result.target === 'object') {
        return result.target;
      }
    }
    return null;
  }

  async duplicateNodesSequentially(nodes, targetParent, startIndex = 0, onComplete = null) {
    if (startIndex === 0) {
      this._createdNodes = [];
    }

    for (let i = startIndex; i < nodes.length; i++) {
      const node = nodes[i];
      console.log(`Duplicando nodo indipendente ${i + 1}/${nodes.length}: ${node.name}`);

      try {
        const data = await this.duplicateRequestPromise({
          source_uuid: node.uuid,
          target_parent_uuid: targetParent.uuid
        });

        const result = await this.blockingProgressModal.watch(data.jid);

        console.log('BlockingProgressModal result:', result);
        console.log('Result keys:', Object.keys(result));

        const createdNode = this.parseCreatedNode(result);
        if (createdNode && createdNode.uuid) {
          console.log('Found created node:', createdNode);
          this._createdNodes.push(createdNode);
        } else {
          console.warn('No created node found in result:', result);
        }

        await new Promise(resolve => setTimeout(resolve, 500));

      } catch (error) {
        console.error(`Errore duplicando il nodo ${node.name}:`, error);
      }
    }

    console.log('Tutti i nodi indipendenti sono stati duplicati, _createdNodes:', this._createdNodes);
    if (onComplete) {
      onComplete();
    } else {
      this.finalizeMultipleDuplication(targetParent);
    }
  }

  duplicateRequestPromise(data) {
    return new Promise((resolve, reject) => {
      duplicateRequest(data)
          .done(resolve)
          .fail(reject);
    });
  }

  // Deseleziona tutte le checkbox
  clearAllSelections() {
    if (this.tree && this.tree.tree) {
      this.tree.tree.visit(node => {
        node.setSelected(false);
      });
    }
  }

// Aggiorna la UI della selezione multipla
  updateMultiSelectionUI() {
    const selectedNodes = this.getSelectedNodes();
    const count = selectedNodes.length;
    const toolbar = $('#multiple-selection-toolbar');

    if (count > 0) {
      toolbar.removeClass('hidden');
      toolbar.find('.selection-count').text(`${count} selezionati`);
    } else {
      toolbar.addClass('hidden');
    }
  }

  initializeMultipleSelectionToolbar() {
    // Toolbar per azioni multiple
    $('body').append(`
    <div class="multiple-selection-toolbar hidden" id="multiple-selection-toolbar">
      <span class="selection-count">0 selezionati</span>
      <button class="btn btn-sm btn-primary" id="copy-multiple" title="Copia selezione">
        <i class="fas fa-copy"></i> Copia
      </button>
      <button class="btn btn-sm btn-danger" id="delete-multiple" title="Elimina selezione">
        <i class="fas fa-trash"></i> Elimina
      </button>
      <button class="btn btn-sm btn-secondary" id="clear-selection" title="Deseleziona tutto">
        <i class="fas fa-times"></i> Deseleziona
      </button>
    </div>
  `);

    // Event handlers
    $('#copy-multiple').on('click', () => this.handleMultipleClipboardCopy());
    $('#clear-selection').on('click', () => this.clearAllSelections());
    $('#delete-multiple').on('click', () => this.handleMultipleDelete());
  }

  showTemporaryMessage(message) {
    const $message = $(`
    <div class="temporary-message">
      <i class="fas fa-check"></i> ${message}
    </div>
  `);

    $('body').append($message);

    setTimeout(() => {
      $message.fadeOut(300, () => $message.remove());
    }, 2000);
  }

  initializeVisualizationType() {
    this.VisualizationTypeEnum = {
      'thumb-grid': { id: 0, name: 'thumb-grid', selector: '.thumb-grid', propertyName: 'thumbGrid', buttonSelector: '.show-as-thumb-grid-button'},
      'datatable': { id: 1, name: 'datatable', selector: '.datatable', propertyName: 'datatable', buttonSelector: '.show-as-datatable-button'}
    };
    this.visualizationTypeDefault = this.VisualizationTypeEnum['datatable'];
    this.visualizationType = this.visualizationTypeDefault;
  }

  showCurrentVisualizationTypeElement() {
    _.values(this.VisualizationTypeEnum).forEach((type, index, array) => {
      const nextType = this.getNextVisualizationType();
      if(type.name === this.visualizationType.name) {
        $(type.selector).removeClass('dam-hidden');
        $(type.buttonSelector).addClass('dam-hidden');
        $(nextType.buttonSelector).removeClass('dam-hidden');
      } else {
        $(type.selector).addClass('dam-hidden');
      }
    });
  }

  getNextVisualizationType() {
    const nextIndex = (this.visualizationType.id + 1) % _.size(this.VisualizationTypeEnum);
    return _.find(this.VisualizationTypeEnum, { id: nextIndex });
  }

  setNextVisualizationType() {
    this.visualizationType = this.getNextVisualizationType();
    this.showCurrentVisualizationTypeElement();
  }

  initializeSidebar() {
    this.sidebar = new Sidebar();
    const node = this.tree.findNode(this.state.current_uuid);
    this.showSidebar(node.data);
  }

  // destroyUploader() {
  //   if (!this.uploader) { return; }
  //   this.uploader.destroy();
  //   this.uploader = undefined;
  // }

  // initializeUploader(node) {
  //   this.destroyUploader();
  //   this.uploader = new Uploader(
  //     '#assets-dropzone',
  //     {
  //       railsApi: {
  //         initUploadUrl: Routes.init_upload_admin_assets_path({resource_uuid: node.uuid}),
  //         authenticityToken: gon.authenticity_token
  //       }
  //     }
  //   );
  // }

  initializeMoveNodeModal() {
    this.moveNodeModal = new MoveNodeModal({
      bundle_id: this.state.bundle_id,
      onMove: (node, oldParent, newParent) => {
        this.handleNodeMoved(node, oldParent, newParent);
      }
    });
  }

  initializeNewChildNodeModal() {
    this.newChildNodeModal = new NewChildNodeModal({
      bundle_id: this.state.bundle_id,
      onCreate: (node, parent) => {
        this.handleChildNodeCreated(node, parent);
      }
    });
  }

  initializeAddResourcesModal() {
    this.addResourcesModal = new AddResourcesModal({
      bundle_id: this.state.bundle_id,
      onSubmit: (parent, nodes) => {
        this.handleAddedResources(parent, nodes);
      }
    });
  }

  initializeBlockingProgressModal() {
    this.blockingProgressModal = new BlockingProgressModal({
      // onSubmit: (parent, nodes) => {
      //   this.handleAddedResources(parent, nodes);
      // }
    });
  }

  destroyGroupToolbar() {
    if(this.groupToolbar) {
      this.groupToolbar.destroy();
      this.groupToolbar = undefined;
    }
  }

  initializeGroupToolbar() {
    this.destroyGroupToolbar();
    this.groupToolbar = new GroupToolbar(this);
    const node = this.tree.findNode(this.state.current_uuid).data;
    if(node.typology === 'root_typology') {
      this.groupToolbar.disableVisitParentButton();
    } else {
      this.groupToolbar.enableVisitParentButton();
    }
  }

  destroyDatatable() {
    if (this.datatable) {
      this.datatable.destroy();
      this.datatable = undefined;
    }
  }

  initializeDatatable() {
    this.destroyDatatable();
    this.datatable = new Datatable(this);
  }

  destroyThumbGrid() {
    if(this.thumbGrid) {
      this.thumbGrid.destroy();
      this.thumbGrid = undefined;
    }
  }

  initializeThumbGrid() {
    this.destroyThumbGrid();
    this.thumbGrid = new ThumbGrid(this);
  }

  collapseSideNav(){
    // admin-lte 3
    $('[data-widget="pushmenu"]').PushMenu('expand');
    $('[data-widget="pushmenu"]').PushMenu('collapse');
    // admin-lte 2
    // window.AdminLTE.pushMenu.expand();
    // window.AdminLTE.pushMenu.collapse();
  }

  removeBreadcrumbsBorder() {
    $('ol.breadcrumb').css('border-bottom', 'none');
  }

  removeFooter() {
    $('footer.main-footer').remove();
  }

  setContentHeight() {
    const headerHeight = $('header.main-header').height();
    const breadcrumbsHeight = 36;
    // .outerHeight and .heigh behave differently between firefox and chrome...
    // const browseHeaderHeight = $('.browse-container__header').outerHeight() + parseInt($('.browse-container__header').css('margin-top')) - 4;
    const browseHeaderHeight = 40;
    const footerHeight = $('footer.main-footer').outerHeight();
    const bodyHeight = $('body').height();
    let visibleContentHeight = (bodyHeight - headerHeight - breadcrumbsHeight - browseHeaderHeight);

    if(footerHeight) {
      visibleContentHeight -= footerHeight;
    }

    $('.content .browse-container').css({
      'height': visibleContentHeight + 'px',
      'maxHeight': visibleContentHeight + 'px',
    });
  }

  // ACTION initialization
  load() {
    this.state = Object.assign(INITIAL_STATE, {
      bundle_id: gon.bundle_id,
      current_uuid: gon.current_uuid,
      readOnly: gon.read_only
    });

    // Initialization
    this.enableVersionSwitch();
    this.initializeTree();
    this.initializeSidebar();
    this.initializeVisualizationType();
    this.initializeGroupToolbar();
    this.showCurrentVisualizationTypeElement();
    this.initializeDatatable();
    this.initializeThumbGrid();
    this.initializeMoveNodeModal();
    this.initializeNewChildNodeModal();
    this.initializeAddResourcesModal();
    this.initializeBlockingProgressModal();
    this.initializeMultipleSelectionToolbar();

    this.queryMetaSearch = new QueryMetaSearch(gon.autocompleter_list);

    eventsListener.initialize(this);

    // Operations
    this.tree.setCurrent(this.state.current_uuid);

    // View related operations
    // this.collapseSideNav(); // temporary disabled until we figure out admin lite v3 js
    this.removeBreadcrumbsBorder();
    this.removeFooter();
    this.setContentHeight();
    $(window).resize(() => {
      this.setContentHeight();
    });

    // TODO: remove
    window.browse = this;
  }

  disableSidebarEditing() {
    $('.browse-container').find('.editable-bundle-meta-datum').addClass('plain-text');
    $('.browse-container').find('.editable-bundle-meta-datum--general-title').addClass('plain-text');
    $('.browse-container').find('.Sidebar .metadata__actions').addClass('dam-hidden');
    $('.browse-container').find('.Sidebar .metadata__entries .datum__remove').addClass('dam-hidden');
  }

  enableVersionSwitch() {
    const $versionSelectElement =  $('body').find('.root-info__release-version select');
    $versionSelectElement.select2({
      minimumResultsForSearch: -1,
      templateResult: function (d) { return $(d.text); },
      templateSelection: function (d) { return $(d.text); }
    });
    $versionSelectElement.on('select2:select', e => {
      window.location.href = e.params.data.element.dataset['url'];
    });
  }

  destroyVersionSwitch() {
    $('body').find('#select2-release-versions-container').closest('span.select2.select2-container').remove();
  }

  destroy() {
    eventsListener.destroy(this);

    this.destroyTree();
    this.destroyGroupToolbar();
    this.destroyDatatable();
    this.destroyThumbGrid();
    this.destroyVersionSwitch();

    if (this.sidebar) {
      // this.closeSidebar();
      this.sidebar.destroy();
      this.sidebar = undefined;
    }

    if (this.moveNodeModal) {
      this.moveNodeModal.destroy();
      this.moveNodeModal = undefined;
    }

    if (this.newChildNodeModal) {
      this.newChildNodeModal.destroy();
      this.newChildNodeModal = undefined;
    }

    if (this.addResourcesModal) {
      this.addResourcesModal.destroy();
      this.addResourcesModal = undefined;
    }

    if (this.blockingProgressModal) {
      this.blockingProgressModal.destroy();
      this.blockingProgressModal = undefined;
    }

    if (this.queryMetaSearch) {
      this.queryMetaSearch.destroy();
      this.queryMetaSearch = undefined;
    }
  }
}
